﻿export const environment = {
  SERVER_URL: `/srm/`,
  SIP_SERVER_URL: '/sip/',
  REPORT_URL:'http://112.17.59.161:10088/webroot/decision/view/report?viewlet=workshop/SRMdev/',
  OA_SERVER_URL: 'http://10.20.20.40:8089/',
  production: false,
  useHash: true,
  hmr: false,
  test: false,
  prod:false
};
